module.exports = __webpack_public_path__ + "static/img/zc.09e8a844.png";